import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface CabrioletSelectedIconProps {
  color?: Color;
}

const CabrioletSelectedIcon: React.FC<CabrioletSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_45159)">
      <path
        d="M24.0601 16.6C14.7401 16.88 10.23 18.12 7.60001 19.55C6.64569 19.9899 5.83827 20.6954 5.27433 21.5821C4.71039 22.4688 4.41386 23.4992 4.42008 24.55C4.33464 25.6737 4.36813 26.8033 4.52006 27.92C4.76006 28.58 10.2901 29.04 10.2901 29.04L64.6701 28.16C66.83 28.0317 68.9783 27.7544 71.1 27.33C72.56 26.85 72.51 23.87 72.51 22.97C72.4816 22.6679 72.3743 22.3786 72.1988 22.1312C72.0232 21.8837 71.7857 21.6867 71.51 21.56C71.324 20.9085 71.2166 20.2371 71.1901 19.56C71.2452 18.3769 70.9569 17.203 70.36 16.18C69.47 14.85 56.96 15.26 49.36 15.59L47.1801 15.69C47.1101 15.69 47.03 15.55 46.97 15.35C46.8991 15.1449 46.8457 14.9341 46.8101 14.72C46.7881 14.5653 46.7355 14.4164 46.6556 14.2821C46.5756 14.1478 46.4698 14.0308 46.3442 13.9377C46.2186 13.8447 46.0758 13.7775 45.924 13.7402C45.7722 13.7028 45.6146 13.6959 45.4601 13.72C44.8001 13.72 44.79 14.3 44.72 15.05C44.7183 15.4455 44.7519 15.8404 44.8201 16.23H42.8201C39.6801 16.3 25.7701 16.58 24.6801 16.59L24.0601 16.6Z"
        fill={color}
        stroke={color}
        strokeWidth="0.75"
      />
      <path d="M25.97 27.85L49.74 27.62" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M23.1901 27.32C23.2573 28.4969 22.9188 29.6612 22.2311 30.6185C21.5433 31.5759 20.5479 32.2684 19.4111 32.5803C18.2744 32.8922 17.065 32.8047 15.985 32.3324C14.905 31.8601 14.0196 31.0316 13.4768 29.9852C12.934 28.9388 12.7667 27.7379 13.0027 26.583C13.2387 25.428 13.8636 24.389 14.7733 23.6394C15.6831 22.8897 16.8225 22.4749 18.0012 22.4641C19.18 22.4533 20.3267 22.8472 21.25 23.58"
        fill={color}
      />
      <path
        d="M23.1901 27.32C23.2573 28.4969 22.9188 29.6612 22.2311 30.6185C21.5433 31.5759 20.5479 32.2684 19.4111 32.5803C18.2744 32.8922 17.065 32.8047 15.985 32.3324C14.905 31.8601 14.0196 31.0316 13.4768 29.9852C12.934 28.9388 12.7667 27.7379 13.0027 26.583C13.2387 25.428 13.8636 24.389 14.7733 23.6394C15.6831 22.8897 16.8225 22.4749 18.0012 22.4641C19.18 22.4533 20.3267 22.8472 21.25 23.58"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M62.3201 27.32C62.3805 28.3415 62.1357 29.358 61.617 30.2401C61.0982 31.1222 60.3289 31.8302 59.4068 32.274C58.4847 32.7178 57.4514 32.8774 56.4384 32.7325C55.4254 32.5876 54.4783 32.1447 53.7176 31.4602C52.9569 30.7757 52.4168 29.8805 52.1662 28.8883C51.9155 27.8961 51.9656 26.8518 52.31 25.8881C52.6543 24.9245 53.2775 24.085 54.1001 23.4763C54.9228 22.8677 55.9078 22.5174 56.9301 22.47C58.1797 22.4091 59.409 22.8035 60.3901 23.58"
        fill={color}
      />
      <path
        d="M62.3201 27.32C62.3805 28.3415 62.1357 29.358 61.617 30.2401C61.0982 31.1222 60.3289 31.8302 59.4068 32.274C58.4847 32.7178 57.4514 32.8774 56.4384 32.7325C55.4254 32.5876 54.4783 32.1447 53.7176 31.4602C52.9569 30.7757 52.4168 29.8805 52.1662 28.8883C51.9155 27.8961 51.9656 26.8518 52.31 25.8881C52.6543 24.9245 53.2775 24.085 54.1001 23.4763C54.9228 22.8677 55.9078 22.5174 56.9301 22.47C58.1797 22.4091 59.409 22.8035 60.3901 23.58"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M71.4001 17.24H70.85L68.4601 17.39C68.4201 17.3922 68.3812 17.4044 68.3471 17.4254C68.313 17.4465 68.2847 17.4758 68.2648 17.5106C68.2449 17.5454 68.234 17.5846 68.2332 17.6247C68.2324 17.6647 68.2416 17.7044 68.2601 17.74C68.48 18.1541 68.6737 18.5816 68.84 19.02C68.8569 19.0701 68.8893 19.1135 68.9324 19.144C68.9755 19.1746 69.0273 19.1907 69.0801 19.19C69.7101 19.19 71.1501 19.01 71.1501 19.01L71.8101 18.95"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4001 20.57C11.9885 21.052 11.6172 21.5671 11.2901 22.11C11.2685 22.1495 11.2366 22.1824 11.1979 22.2052C11.1592 22.2281 11.1151 22.2401 11.0701 22.24C10.2301 22.24 8.20012 22.3 8.07012 22.24C7.94012 22.18 7.80012 21.47 8.07012 21.24C8.34012 21.01 8.99007 20.24 12.2701 20.13C12.3214 20.1306 12.3712 20.1476 12.4122 20.1785C12.4531 20.2095 12.4831 20.2528 12.4976 20.302C12.5122 20.3512 12.5105 20.4038 12.493 20.4521C12.4754 20.5003 12.4429 20.5416 12.4001 20.57Z"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M34.03 11.36C30.6902 12.8445 27.4588 14.562 24.36 16.5L24.14 16.66" fill={color} />
      <path
        d="M34.03 11.36C30.6902 12.8445 27.4588 14.562 24.36 16.5L24.14 16.66"
        stroke={color}
        strokeWidth="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_45159">
        <rect width="68.88" height="22.02" fill="white" transform="translate(4 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default CabrioletSelectedIcon;
